import styled, { keyframes } from "styled-components";

// Fundo que pulsa enquanto a foto ainda baixa (esqueleto da galeria); a imagem cobre quando chega (anima so a cor de fundo, nunca a opacidade da foto).
const pulso = keyframes`0%{background-color:#E6E9E7}50%{background-color:#D3D9D5}100%{background-color:#E6E9E7}`;

// Modal de informações do plantio. Antes era um cartão de 360px com a galeria em
// 291px e as informações numa caixa de 160px com rolagem própria: tudo espremido.
// Agora é largo (até 1040px), com a galeria grande de um lado e as informações do
// outro; em tela estreita volta a uma coluna. O fundo rola, o cartão não tem
// rolagem interna.
export const Main = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
  padding: 32px 16px;
  background-color: rgba(0, 0, 0, 0.45);
`;

export const Container = styled.div`
  width: min(1040px, 100%);
  margin: auto;
  background-color: #fff;
  border-radius: 14px;
  padding: 28px 32px 32px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, .25);

  .topo{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;

    .rotulo-modal{
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: .05em;
      color: #6B6E70;
    }

    .fechar{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border: none;
      border-radius: 8px;
      background: transparent;
      cursor: pointer;
      &:hover{ background: #F1F2F4; }
      &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
      img{ width: 18px; }
    }
  }

  .corpo{
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    gap: 32px;
    align-items: start;
  }

  /* ---- Galeria ---- */
  .coluna-galeria{ min-width: 0; }

  .gallery{
    position: relative;
    width: 100%;

    .images{
      display: flex;
      overflow: hidden;
      border-radius: 12px;
      background: #efefef;

      .image{
        flex: 0 0 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: clamp(260px, 46vh, 480px);
        background: #E6E9E7;
        animation: ${pulso} 1.4s ease-in-out infinite;
        @media (prefers-reduced-motion: reduce){ animation: none; }

        img, video{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &.sem-midia{ color: #6B6E70; font-size: 14px; }
      }
    }

    .next, .previus{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      button{
        display: flex;
        border: none;
        border-radius: 10px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        height: 40px;
        width: 40px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 1px 6px rgba(0,0,0,.25);
        &:hover{ background: #fff; }
        &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
        img{ height: 14px; }
      }
    }

    .next{ right: 12px; }
    .previus{ left: 12px; }
  }

  .contagem-fotos{
    display: block;
    margin-top: 8px;
    font-size: 12px;
    color: #6B6E70;
  }

  /* ---- Informações ---- */
  .coluna-info{ min-width: 0; margin-top: 0; }

  .titulo-plantio{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 18px;

    h2{
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      line-height: 125%;
      overflow-wrap: anywhere;
    }

    .selo{
      flex-shrink: 0;
      margin-top: 4px;
      padding: 3px 12px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 700;
      border: 1px solid transparent;
      &.individual{ background: #F1F2F4; color: #4D4F50; border-color: #DDDFE3; }
      &.area{ background: #E4F4E7; color: #1f7a33; border-color: #BFE0C5; }
    }
  }

  .grade-info{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    .item{
      display: flex;
      align-items: flex-start;
      gap: 10px;
      min-width: 0;

      &.largo{ grid-column: 1 / -1; }

      > img{ width: 18px; margin-top: 2px; flex-shrink: 0; }

      > div{ display: flex; flex-direction: column; gap: 2px; min-width: 0; }
    }
  }

  .rotulo{
    font-size: 12px;
    font-weight: 700;
    color: #6B6E70;
  }

  .details{
    font-size: 15px;
    font-weight: 500;
    line-height: 140%;
    color: #1E1F20;
    overflow-wrap: anywhere;

    &.secundario{ font-size: 13px; color: #6B6E70; }
  }

  .destaque-area .area-valor{ font-size: 20px; font-weight: 700; color: #1f7a33; }

  .bloco-mapa-area{
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bloco-especies{
    margin-top: 22px;
    padding-top: 18px;
    border-top: 1px solid #EFF0F2;

    .cabecalho-especies{
      display: flex;
      align-items: center;
      gap: 10px;

      img{ width: 16px; }

      .total-mudas{
        margin-left: auto;
        font-size: 13px;
        font-weight: 700;
        color: var(--primary-color);
      }
    }

    .lista-especies{
      list-style: none;
      margin: 12px 0 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;

      li{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 10px 12px;
        border-radius: 8px;
        background: #FAFBFA;
        border: 1px solid #EFF0F2;

        &.vazio{ color: #6B6E70; font-size: 14px; }
      }

      .nome{
        display: flex;
        flex-direction: column;
        font-size: 15px;
        font-weight: 600;
        min-width: 0;
        em{ font-size: 12px; font-weight: 400; color: #6B6E70; }
      }

      .mudas{
        flex-shrink: 0;
        font-size: 13px;
        font-weight: 700;
        color: #1f7a33;
      }
    }
  }

  .bottom{
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 28px;

    button{
      min-width: 160px;
      height: 44px;
      padding: 6px 20px;
      color: #fff;
      border-radius: 8px;
      border: none;
      background-color: var(--primary-color);
      cursor: pointer;
      font-family: inherit;
      font-size: 14px;
      font-weight: 700;
      &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }

      &.secundario{
        background: transparent;
        color: var(--primary-color);
        border: 1.5px solid var(--primary-color);
      }
    }
  }

  @media (max-width: 860px){
    padding: 20px 18px 24px;
    .corpo{ grid-template-columns: minmax(0, 1fr); gap: 20px; }
    .titulo-plantio h2{ font-size: 21px; }
    .grade-info{ grid-template-columns: 1fr; }
    .bottom{ flex-direction: column-reverse; button{ width: 100%; } }
  }
`;
